export default __webpack_public_path__ + "static/media/ICCCAD-logo(transparent4k).ae9a6c79.png";